import {
  Edit,
  CardActions,
  ListButton,
  RefreshButton,
  translate
} from "react-admin";
import React from "react";

import RoomForm from "./RoomForm";

const RoomTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("room.room")}`} {record ? `"${record.name}"` : ""}
    </span>
  );
};

const Title = translate(RoomTitle);

const Actions = ({ basePath, data, resource }) => (
  <CardActions>
    <ListButton basePath={basePath} />
    {/* <DeleteButton basePath={basePath} record={data} resource={resource} /> */}
    <RefreshButton />
  </CardActions>
);

export const RoomEdit = props => {
  return (
    <Edit actions={<Actions />} title={<Title />} {...props}>
      <RoomForm />
    </Edit>
  );
};



// WEBPACK FOOTER //
// ./src/components/room/RoomEdit.js